module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "feature-area section-padding2 toubugaodu",
    staticStyle: {
      "height": "400px",
      "background": "url('../static/assets/images/bannerc.jpg') no-repeat",
      "background-size": "100% auto"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "about_tab"
  }, [_c('router-link', {
    staticClass: "about_tab_jj",
    staticStyle: {
      "background": "#0473db",
      "color": "#ffffff"
    },
    attrs: {
      "to": "/about"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_wh",
    attrs: {
      "to": "/wenhua"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_jg",
    attrs: {
      "to": "/jiagou"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("企业架构")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_zr",
    attrs: {
      "to": "/zeren"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("认证体系")]), _vm._v(" "), _c('router-link', {
    staticClass: "about_tab_sm",
    attrs: {
      "to": "/shengming"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("版权声明")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "feature-area section-padding2 about_section1"
  }, [_c('div', {
    staticClass: "container about912",
    staticStyle: {
      "padding-top": "100px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "0px 8%",
      "line-height": "36px",
      "font-size": "16px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.aboutinfo.content)
    }
  })]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row toubugaoduzt",
    staticStyle: {
      "height": "400px",
      "line-height": "400px",
      "color": "#ffffff",
      "font-size": "45px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('p', {
    staticStyle: {
      "font-style": "initial"
    }
  }, [_vm._v("关于我们")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "130px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', [_vm._v("烟台拿度智能科技有限公司")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "line-height": "50px",
      "font-size": "16px"
    }
  }, [_vm._v("专注于工业自动化测控领域的应用产品开发与技术服务")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buxianshi",
    staticStyle: {
      "width": "80%",
      "margin-left": "10%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px",
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/aboutds.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#e40230"
    }
  }, [_vm._v(" ♥ ")]), _vm._v(" 核心价值观")]), _vm._v(" "), _c('p', [_vm._v("协作 、责任 、进步")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#e40230"
    }
  }, [_vm._v(" ♥ ")]), _vm._v(" 企业愿景")]), _vm._v(" "), _c('p', [_vm._v("专注于工业自动化测控领域的应用产品开发与技术服务")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "22px",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticStyle: {
      "color": "#e40230"
    }
  }, [_vm._v(" ♥ ")]), _vm._v(" 不朽使命")]), _vm._v(" "), _c('p', [_vm._v("我们追求在瞬息万变的高科技测控世界里，创造不朽的品质和价值。不朽精神将会以无限的可能传递和延申，为您，也为我们自己。")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "team-area section-padding2"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "advantage_num"
  }, [_c('ul', [_c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage01.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("6")]), _c('i', [_vm._v("大")])]), _vm._v(" "), _c('p', [_vm._v("主要业务板块，"), _c('br'), _vm._v("\n                磁致伸缩位移传感器、激光传感器")])])]), _vm._v(" "), _c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage02.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("10")]), _c('i', [_vm._v("年")])]), _vm._v(" "), _c('p', [_vm._v("十年以上的行业经验，"), _c('br'), _vm._v("\n                强大的传感器研发、设计和测试工程师团队")])])]), _vm._v(" "), _c('li', {
    staticClass: "wow fadeInLeft animated",
    staticStyle: {
      "visibility": "visible",
      "animation-name": "fadeInLeft"
    }
  }, [_c('div', {
    staticClass: "img_box"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/advantage03.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text_box"
  }, [_c('span', [_c('em', {
    staticClass: "counter"
  }, [_vm._v("60")]), _c('i', [_vm._v("种")])]), _vm._v(" "), _c('p', [_vm._v("位移传感器产品，"), _c('br'), _vm._v("\n                技术上追求“度”，做事上立本于“度”")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7244a5bd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/About.vue
// module id = 109
// module chunks = 0